import { FC } from 'react';
import { TitleRow } from 'components/TitleRow';
import styles from './AlertsWorkSupportList.module.scss';
import { CustomerAlertsWorkSupport } from 'ui/CustomerAlertsWorkSupport';

export const AlertsWorkSupportList: FC<any> = ({
  alertsList,
  intersectionRef,
  setShowModalCancelAlert,
  setShowModalCreateAlert,
  setInitialData,
  setCancelAlertId,
  setButtonCreateAlert,
}) => {
  const dataTitle = [
    'Дата создания',
    'Дата начала',
    'Дата завершения',
    'Заголовок',
    'Тело сообщения',
  ];

  return (
    <div className={styles.root}>
      <TitleRow data={dataTitle} title={'alertsWorkSupport'} />
      {alertsList ? (
        alertsList.map((elem: any, index: number) => {
          const triggerIndex = Math.max(0, alertsList.length - 15);
          const shouldAttachRef = index === triggerIndex;

          return (
            <div key={index} ref={shouldAttachRef ? intersectionRef : undefined}>
              <CustomerAlertsWorkSupport
                alert={elem}
                setShowModalCancelAlert={setShowModalCancelAlert}
                setShowModalCreateAlert={setShowModalCreateAlert}
                setInitialData={setInitialData}
                setCancelAlertId={setCancelAlertId}
                setButtonCreateAlert={setButtonCreateAlert}
              />
            </div>
          );
        })
      ) : (
        <div className={styles.root_nothing}>
          <p>Ничего не найдено</p>
        </div>
      )}
    </div>
  );
};
